
import {Vue, Component, Emit} from "vue-property-decorator";
import {loadModules} from "esri-loader";
import {debounce} from "ts-debounce-throttle";
import MapApp from "@/plugin/gis-viewer/MapAppArcgis3D";
import BubbleLayer from "@/plugin/gis-viewer/widgets/Animation/BubbleLayer";

@Component({
  name: "MiniMapArcgisThreeD"
})
export default class MiniMap_ArcGIS3D extends Vue {
  private mapId: string = "divArcGISMap3D" + (Math.random() * 10000).toFixed(0);
  private bigMapView!: __esri.SceneView;
  public miniMapView!: __esri.MapView;
  private ready: boolean = false;

  @Emit("minimap-mouse-over")
  private onMouseOver() {}

  @Emit("minimap-mouse-out")
  private onMouseOut() {}

  public async initialize(
    mapApp: MapApp,
    defaultVisible?: boolean,
    config?: any
  ) {
    this.bigMapView = mapApp.view;
    type MapModules = [
      typeof import("esri/views/SceneView"),
      typeof import("esri/views/MapView"),
      typeof import("esri/Map")
    ];
    const [SceneView, MapView, Map] = await (loadModules([
      "esri/views/SceneView",
      "esri/views/MapView",
      "esri/Map"
    ]) as Promise<MapModules>);
    const map = new Map({basemap: this.bigMapView.map.basemap});
    const viewpoint = this.bigMapView.viewpoint.clone();
    let options: any = {};
    options.scale = viewpoint.scale * 2;
    options.center = [this.bigMapView.center.x, this.bigMapView.center.y];
    //viewpoint.camera.tilt = 0;
    //viewpoint.camera.position.x = this.bigMapView.center.x;
    //viewpoint.camera.position.y = this.bigMapView.center.y;
    if (config) {
      // viewpoint.camera.position = {
      //   longitude: config.position[0],
      //   latitude: config.position[1],
      //   z: config.position[2] // altitude in meters
      // } as __esri.Point;
      if (config.position) {
        options.center = [config.position[0], config.position[1]];
      }
      if (config.zoom) {
        options.zoom = config.zoom;
      }
    }

    this.miniMapView = new MapView({
      map,
      container: this.mapId,
      ...options
    });
    this.miniMapView.ui.remove([
      "attribution",
      "zoom",
      "compass",
      "navigation-toggle"
    ]);

    /** 禁止除点击以外的交互 */
    this.miniMapView.on("double-click", (event) => {
      event.stopPropagation();
    });
    this.miniMapView.on("drag", (event) => {
      event.stopPropagation();
    });
    this.miniMapView.on("mouse-wheel", (event) => {
      event.stopPropagation();
    });
    this.miniMapView.on("click", (event) => {
      const mapPoint = event.mapPoint;
      this.bigMapView.goTo(mapPoint);
    });

    // this.bigMapView.watch("interacting,animation", () => {
    //   setTimeout(() => {
    //     this.bigMapView.watch("viewpoint", (value: __esri.Viewpoint) => {
    //       const viewpoint = value.clone();
    //       viewpoint.scale *= 2;
    //       viewpoint.camera.tilt = 0;
    //       viewpoint.camera.position.x = this.bigMapView.center.x;
    //       viewpoint.camera.position.y = this.bigMapView.center.y;
    //       this.miniMapView.viewpoint = viewpoint;
    //     });
    //   }, 0);
    // });

    if (defaultVisible !== false) {
      this.ready = true;
    }
  }
}
